<template>
    <div>
        <div class="cb">
            <span class="line fl"></span>
            <span class="fl dc">更换头像</span>
        </div>

        <div class="box">
            <div :class="`avatar-box${is_drag ? ' img-drag' : ''}`" @drop.prevent="drop" @dragover.prevent @dragenter.prevent="is_drag = true" @dragleave="is_drag = false">
                <label v-show="!cro.ready" for="upload" class="avatar-container">
                    <i class="icon-image"></i>
                    <br>
                    点击选择图片
                    <br>
                    或将图片拖至此处
                </label>
                <img ref="avatar" class="dn" :src="src" alt="avatar">
                <input type="file" id="upload" class="dn" accept="image/png,image/jpg,image/jpeg" @change="change">
            </div>
            <div class="preview-box">
                <div ref="preview" class="preview-container" :style="`background-image: url('${user.thumb}')`"></div>
                {{cro.ready ? '预览' : '当前'}}头像
            </div>
        </div>

        <div :class="`again-box${cro.ready ? '' : ' vh'}`">
            <label for="upload" class="again"><i class="icon-again"></i>点击或拖动图片重新选择</label>
            <div class="empty"></div>
        </div>

        <p class="tip">请选择图片上传：支持JPG、PNG等格式，图片需小于2M</p>

        <div class="submit-box">
            <span :class="`submit-btn bg${cro.ready ? '' : ' disabled'}`" @click="send">
                <span v-show="!is_loading" class="submit-text">更新</span>
                <span v-show="is_loading" class="submit-text loading">&nbsp;</span>
            </span>
        </div>
    </div>
</template>

<script>
    import 'cropperjs/dist/cropper.css';
    import Cropper from 'cropperjs';

    export default {
        data: () => ({
            is_drag: false,
            src: '',
            cro: {},
            previewImg: null,
            is_loading: false,
        }),
        methods: {
            initCrop() {
                let {avatar, preview} = this.$refs;

                if (this.cro.ready) {// 已初始化 则直接替换图片
                    this.cro.replace(this.src);
                    this.previewImg.src = this.src;
                } else {// 进行初始化

                    this.cro = new Cropper(avatar, {
                        aspectRatio: 1,
                        viewMode: 1,
                        zoomable: false,
                        /*minCanvasHeight: 1000,
                        minCanvasWidth: 1000,*/
                        /*minContainerWidth: 320,
                        minContainerHeight: 180,*/

                        minCropBoxWidth: 1,
                        minCropBoxHeight: 1,
                        ready: () => {
                            let clone = avatar.cloneNode();
                            clone.className = 'clone';
                            preview.appendChild(clone.cloneNode());
                            this.previewImg = preview.firstElementChild;
                            this.cro.setCropBoxData({width: 200, height: 200});// 设置初始裁剪框宽高后 会调用crop一次 完美解决初次选择图片时的定位问题
                        },

                        crop: e => {// 此方法在初始化时会先调用一次 但此时ready函数还没有运行 所以需要进行判断previewImg
                            let {detail} = e,
                                imageData = avatar.cropper.getImageData(),
                                previewWidth = preview.offsetWidth,
                                imageScaledRatio = detail.width / previewWidth;

                            if (this.previewImg) {// 若已初始化 则直接改变style
                                this.previewImg.style.cssText = `width: ${imageData.naturalWidth / imageScaledRatio}px;height: ${imageData.naturalHeight / imageScaledRatio}px;transform: translateX(${-detail.x / imageScaledRatio}px) translateY(${-detail.y / imageScaledRatio}px);`;
                            }
                        },
                    });
                }
            },
            drop(e) {
                this.is_drag = false;
                this.reader(e.dataTransfer);
            },
            change(e) {
                this.reader(e.target);
            },
            reader(target) {
                let reader = new FileReader, file = target.files[0];// 实例化FileReader对象

                if (file) {// 存在时文件流时执行
                    if (!file.type.includes('image')) return this.alert.err('请选择图片类型的文件');
                    reader.readAsDataURL(file);
                    reader.onload = e => {
                        this.src = e.target.result;
                        this.$nextTick(() => {
                            this.initCrop();
                        });
                    };
                }
            },
            async put(blob) {
                let {api, user} = this,
                    now = (new Date).toGMTString(),
                    {imgHost, imgCdn} = api,
                    {thumb} = user,
                    authHost = 'users/auth', auth, avatar;

                auth = await api.put(authHost, {now});// 获取上传权限的token
                await api.putFile(imgHost + auth.key, auth.Authorization, now, blob);// 上传头像至OSS
                avatar = imgCdn + auth.key;// 拼接图片CDN地址
                await api.put('users/avatar', {avatar});// 更新数据库头像地址

                user.thumb = avatar;
                this.$router.push('/users');
                window.localStorage.user = JSON.stringify(user);

                if (thumb.includes(imgCdn)) {// 判断头像是否属于CDN
                    let key = thumb.split(`user/${user.id}`)[1];// 获取userId/123后面的部分 传给后台获取code
                    auth = await api.del(authHost, {now, key});// 获取删除权限的token
                    api.delFile(`${imgHost}user/${user.id + key}`, auth.Authorization, now);
                }
            },
            send() {
                if (this.is_loading || !this.cro.ready) return false;
                this.is_loading = true;

                try {
                    this.cro.getCroppedCanvas({width: 180, height: 180}).toBlob(this.put, 'image/jpeg');
                } catch(e) {
                    this.is_loading = false;
                }

            }
        },
        computed: {
            user() {
                return this.$store.state.user;
            }
        }
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/avatar.css";
</style>



// WEBPACK FOOTER //
// src/views/user/Avatar.vue